import React, {useState, useEffect} from 'react';

import {Table} from "../../../common/table/Table";
import {retrieveAllStaffMembers} from "../../../../services/StaffMemberService";

export const StaffMemberTable = ({context, navigateTo, setContext, setSpinnerText, showToaster}) => {

    const [staffMembers, setStaffMembers] = useState([]);

    useEffect(() => {
        setSpinnerText("Retrieving Staff Members");
        const fetchData = async () => {
            const [data, error] = await retrieveAllStaffMembers(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    setStaffMembers(data.systemUserVOList);
                } else {
                    showToaster(data);
                }
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
            setSpinnerText(null);
        }
        fetchData();
    }, []);

    const handleRowClick = (staffMember) => {
        setContext((prevState) => ({
            ...prevState,
            selectedStaffMember: staffMember,
        }))
        navigateTo("staffMemberCapture");
    }

    const handleAddButtonClick = () => {
        setContext((prevState) => ({
            ...prevState,
            selectedStaffMember: null,
        }));
        navigateTo("staffMemberCapture");
    }

    return (
        <div className="admin-table-container">
            <Table tableData={staffMembers}
                   buttonText="Add Staff Member"
                   onButtonClick={handleAddButtonClick}
                   onRowClick={handleRowClick}
                   searchEnabled={true}
                   hiddenColumns={["externalReference", "toolTipsEnabled", "sortBySuggestion", "comprehensiveDisplay", "isDeleted", "created", "lastModified"]}
            />
        </div>
    );
}
